import { Skeleton, TableBody, TableRow } from '@mui/material';
import React from 'react';

interface ChannelViewCommentsTableSkeletonProps {
    isLoading: boolean;
    isError: boolean;
}

const ChannelViewCommentsTableSkeleton: React.FC<
    React.PropsWithChildren<ChannelViewCommentsTableSkeletonProps>
> = (props) => {
    if (props.isLoading) {
        return (
            <TableBody>
                <TableRow>
                    <Skeleton
                        variant="rectangular"
                        width={'100%'}
                        height={48}
                    />
                </TableRow>
            </TableBody>
        );
    }
    return <>{props.children}</>;
};

export default ChannelViewCommentsTableSkeleton;
